module.exports = __webpack_public_path__ + "static/media/image_51.7f58a72e.png";